import {Action} from '@ngrx/store';
import {ContentPoster} from '../../model/content-poster.model';

export const SET_POSTER = '[Without Catchup] Posters set';
export const REMOVE_POSTER = '[Without Catchup] Remove Posters';
export const RESET_POSTER = '[Without Catchup] Reset Poster';
export class SetCatchupPoster implements Action {
  readonly type = SET_POSTER;
  constructor(public payload: ContentPoster) {}
}

export class RemoveCatchupPoster implements Action {
  readonly type = REMOVE_POSTER;
  constructor(public payload: number) {}
}
export class ResetPoster implements Action {
  readonly type = RESET_POSTER;
  constructor(public payload: number) {}
}

export type Actions = SetCatchupPoster | ResetPoster | RemoveCatchupPoster;
